export default () => `
  <div class="content">
    Wind Speed: Occupancy/Risk Category II buildings and systems with a 25 year design life can be designed utilizing the U-Builder. 
    Occupancy/Risk Category II wind speeds as referenced by the Building Code selected above should be inserted in the data field below. 
    If an alternate design is required, please contact <a href=mailto:Engineering.Services@unirac.com>Engineering.Services@unirac.com</a>.
  </div>
`;
